/* eslint-disable react/display-name */
import React, { useContext } from 'react';
import { shape, node } from 'prop-types';

const UserAgentContext = React.createContext();

const UserAgentProvider = ({ userAgent, children }) => (
  <UserAgentContext.Provider value={userAgent}>
    {children}
  </UserAgentContext.Provider>
);

UserAgentProvider.propTypes = {
  userAgent: shape({}).isRequired,
  children: node.isRequired,
};

const withUserAgent = WrappedComponent => (props) => {
  const userAgent = useContext(UserAgentContext);
  return <WrappedComponent {...props} userAgent={userAgent} />;
};

export default withUserAgent;
export {
  UserAgentProvider,
};
